var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
function isTypedSchema(x) {
  return typeof x == "object" && x.__type === "VVTypedSchema";
}
__name(isTypedSchema, "isTypedSchema");
export {
  isTypedSchema
};
//# sourceMappingURL=utils.js.map
